import { connect } from 'react-redux';
import get from 'lodash/fp/get.js';
import { getFormValues } from 'redux-form';
import { SITE_CLASS } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import SiteClassRange from './SiteClassRange.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;

  return {
    siteClass: get(SITE_CLASS, getFormValues(form)(state)),
  };
};

export default connect(mapStateToProps)(SiteClassRange);
